<script lang="ts">
  import { derived } from "svelte/store";
  import Sprite from "../sprite.svelte";
  import { gpsStatus, LOADING, INACTIVE, ACTIVE, FAILED } from "../../services/geolocation";

  export let onLocate: (event: MouseEvent) => void;
  export let isTracking = false;
  export let offset = 0;

  const gpsIcon = derived(gpsStatus, ($gpsStatus) => {
    switch ($gpsStatus) {
      case LOADING:
        return "icon-wait";
      case INACTIVE:
        return "icon-gps-on";
      case ACTIVE:
        return "icon-gps-on";
      case FAILED:
      default:
        return "icon-gps-off";
    }
  });

  const gpsIconColor = derived(gpsStatus, ($gpsStatus) => {
    switch ($gpsStatus) {
      case FAILED:
        return "rgba(200, 100, 100, 0.54)";
      case ACTIVE:
      case INACTIVE:
        return "currentColor";
      case LOADING:
      default:
        return "rgba(100, 100, 100, 0.54)";
    }
  });
</script>

<menu style="--fab-extra-offset: {offset}px;">
  <button
    class="Locate"
    class:tracking={isTracking}
    type="button"
    aria-busy={$gpsStatus == LOADING}
    on:click={onLocate}
  >
    <Sprite icon={$gpsIcon} fill={$gpsIconColor} size={24} />
    {#if $gpsStatus == INACTIVE}
      <span class="Label">Share Location</span>
    {/if}

    {#if $gpsStatus == LOADING}
      <span class="sr-only">Retrieving Location</span>
    {/if}

    {#if $gpsStatus == FAILED}
      <span class="sr-only">Location Error</span>
    {/if}

    {#if $gpsStatus == ACTIVE}
      <span class="sr-only">Sharing Location</span>
    {/if}
  </button>
</menu>

<style>
  menu {
    --fab-size: 48px;
    bottom: calc(var(--fab-position, 0px) + var(--fab-extra-offset, 0px));
    padding: 0 0 var(--fab-offset, 0px);
    position: fixed;
    right: 10px;
    display: flex;
    flex-direction: column;
    margin: 0;
    z-index: 1;
    transition: 0.15s padding;
    touch-action: none; /* avoids scrolling on button*/
    visibility: var(--controls-visibility, visible);
  }

  menu button {
    background: white;
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.12),
      0 2px 5px rgba(0, 0, 0, 0.12);
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: var(--fab-size);
    border-radius: var(--fab-size);
    color: rgba(0, 0, 0, 0.88);
    line-height: 1;
    padding: 0 12px;
  }

  button:disabled {
    opacity: 0.5;
  }

  button:focus {
    outline: none;
  }

  .Label {
    margin-left: 8px;
    text-transform: none;
    letter-spacing: 0;
    font-size: 12px;
  }

  .Locate.tracking {
    color: var(--color-geo-blue);
  }
</style>
